// extracted by mini-css-extract-plugin
export default {"link":"contact_link__Niabi","social-icon":"contact_social-icon__njqdz"};